import styled from "styled-components";

export const Container = styled.div `
    padding: 0 0 100px 0;
`